import React, { Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'

import { ContentBox, TextInput, FormButtons, FormError, PortalForm } from '@portal/kit/pkg/components'
import PageTitle from 'components/login/page-title'

const PasswordRecovery = ({ handleSubmit, submitError, t }) =>
  <Fragment>
    <PageTitle i18nKey='password_recovery.page_title' />
    <ContentBox title={t('portal.reset_password.fill_email')}>
      <PortalForm onSubmit={handleSubmit}>
        {
          submitError && <FormError message={submitError} />
        }
        <TextInput name="email" label={t('portal.reset_password.email')} />
        <FormButtons submit cancel="/" />
      </PortalForm>
    </ContentBox>
  </Fragment>

export default compose(
  withTranslation(),
)(PasswordRecovery)
